<template>
    <label :for="name" class="text-xs leading-3 pb-2 relative" :class="{'text-[#8D8B8F]': disabled}">
        <slot></slot>
    </label>
    <div class="w-full relative">
        <div class="flex items-center rounded"
             :class="[{'bg-white outline outline-2 outline-dark-gray': isActive}, {'bg-[#F2F3F3]': !isActive}, {'outline outline-2 outline-red': !isValid}]">
            <input
                class="outline-none w-full pl-3 py-2.5 bg-transparent font-rubik text-sm"
                :class="{'pr-10':!modelValue}"
                type="text"
                :maxlength="maxValue"
                :id="name"
                v-model="modelValue"
                @focus="isActive = true"
                @blur="isActive = false"
                :disabled="disabled"
                autocomplete="off"
            >
            <button v-show="modelValue && canClear" class="p-2.5" @click="clear()"><span
                class="block h-5 w-5 close-icon cursor-pointer"/></button>
        </div>
        <span class="absolute -right-4 top-4 asterisk-icon" v-if="required"/>
        <span v-if="errorMessage" class="absolute -bottom-4 left-3 text-red font-rubik text-xs leading-3">{{ errorMessage }}</span>
    </div>
</template>

<script setup>
import {computed, ref} from "vue";

let emit  = defineEmits(['update:modelValue', 'clear'])
let props = defineProps({
    modelValue: String,
    name: {
        type: String,
    },
	maxValue: {
		type: Number
	},
    disabled: {
        type: Boolean,
        default: false
    },
    required: {
        type: Boolean,
        default: false
    },
    isValid: {
        type: Boolean,
        default: true
    },
    canClear: {
        type: Boolean,
        default: true
    },
    errorMessage: {
        type: String,
    }
})

let isActive = ref(false);

const modelValue = computed({
    get: () => props.modelValue,
    set: (value) => emit('update:modelValue', value)
})

const clear = function () {
    emit('update:modelValue', null)
    emit('clear')
}
</script>
